import { useEffect, useState } from "react";
import { getRole, type Role } from "@/lib/auth-mock";

export function useRole(): Role {
  const [role, setRoleState] = useState<Role>(getRole());
  useEffect(() => {
    const handler = () => setRoleState(getRole());
    window.addEventListener("infinix:role-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("infinix:role-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return role;
}
